module.exports = __webpack_public_path__ + "img/img_kuaqu.15eef7e7.png";